export default __webpack_public_path__ + "static/N0210-c107bb4c7582944123e4ec2a4ae7363a.png";